import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from '../app/root'
import Home from '../app/routes/home'
//import Album from '../app/routes/album'
import Album from '../app/routes/album'

console.log('Starting app initialization...');

function AlbumRoute() {
  return <Album />
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <Home />
      }
    ]
  },
  {
    path: "/tmp/leren-leven",
    element: <App />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        index: true,
        element: <AlbumRoute />
      }
    ]
  }
])

function ErrorBoundary() {
  return (
    <div className="min-h-screen bg-black text-white p-8">
      <h1 className="text-4xl font-bold mb-4">Error!</h1>
      <p className="text-lg mb-4">Something went wrong. Please try refreshing the page.</p>
      <button 
        onClick={() => window.location.reload()} 
        className="bg-white text-black px-4 py-2 rounded hover:bg-gray-200"
      >
        Refresh Page
      </button>
    </div>
  );
}

console.log('Creating root element...');
const rootElement = document.getElementById('root');
console.log('Root element:', rootElement);

if (!rootElement) {
  console.error('Failed to find root element!');
  throw new Error('Failed to find root element');
}

console.log('Rendering app...');
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
) 